import { FC, MouseEventHandler, useEffect, useState } from "react";
import { useStore } from ".";
import { Button } from "./components/form";
import { useCallback } from "react";
import shallow from "zustand/shallow";

const SearchButton: FC = () => {
  const [isValid, fetchReport, addEventListener, removeEventsListener] =
    useStore(
      useCallback(
        (state) => [
          state.isValid().valid,
          state.fetchReport,
          state.addEventListener,
          state.removeEventListener,
        ],
        []
      ),
      shallow
    );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const searchStart = () => {
      setIsLoading(true);
      window.scrollTo({ top: 0 });
    };
    const searchSuccess = () => {
      setIsLoading(false);
    };

    addEventListener("searchstart", searchStart);
    addEventListener("searchsuccess", searchSuccess);

    return () => {
      removeEventsListener("searchstart", searchStart);
      removeEventsListener("searchsuccess", searchSuccess);
    };
  }, [addEventListener, removeEventsListener]);

  const handleClick: MouseEventHandler = useCallback(async () => {
    await fetchReport();
  }, [fetchReport]);

  return (
    <Button
      id="button-search-result"
      disabled={!isValid || isLoading}
      className={`bg-[#43357F] disabled:bg-[#C2B6CB] ${
        !isLoading ? "disabled:cursor-not-allowed" : "disabled:cursor-progress"
      }`}
      onClick={handleClick}
    >
      Search
    </Button>
  );
};

export default SearchButton;
